import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import Logout from './auth/logout';

class Navbar extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
  };

  render() {
    return (
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars"></i>
            </a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link className="nav-link" to={`${this.props.match?.path}/sale`}>
              Home
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="#">
              {this.props.name}
              <i className="far fa-user ml-2"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <Link
                className="dropdown-item"
                to={`${this.props.match?.path}/profile`}
              >
                <i className="fas fa-id-card mr-2"></i>
                Profile
              </Link>
              <div className="dropdown-divider"></div>
              <Logout />
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  name: state?.auth?.name,
});

export default withRouter(connect(mapStateToProps)(Navbar));
